---
en:
  users:
    flash_account_disabled: The account has been deactivated. Contact support.
    flash_account_locked: The account has been locked. Contact support.
    flash_account_updated: Your account was updated
    flash_password_reset_instructions: We will send an e-mail if we find the account connected to this e-mail
    flash_password_sent: A new password has been sent to
    form:
      clear_companies_confirm: This removes the user's access to every company in this list once you save.
      clear_power_plants_confirm: This removes the user's access to every power plant in this list once you save.
      unlisted_companies: Also has access to one company you cannot assign. It is kept when you save. | Also has access to {count} companies you cannot assign. They are kept when you save.
      unlisted_power_plants: Also has access to one power plant you cannot assign. It is kept when you save. | Also has access to {count} power plants you cannot assign. They are kept when you save.
    locales:
      de: DE
      en: EN
      fr: FR
      nb: 'NO'
    password_notice: Leave he password field blank to the keep the password unchanged
    users: Users
